import { render, staticRenderFns } from "./ButtonActive.vue?vue&type=template&id=220ad3cd&scoped=true&"
import script from "./ButtonActive.vue?vue&type=script&lang=js&"
export * from "./ButtonActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ad3cd",
  null
  
)

export default component.exports